<script module lang="ts">
  import type { HTMLAttributes } from 'svelte/elements';
  import type { NavPoints } from '../components/navigation/navigation.types';
  import type { NavigationVariant } from '../handlers/NavigationHandler';
</script>

<script lang="ts">
  import { CommonTexts } from '../services/CommonTexts';
  import Navigation from '../components/navigation/Navigation.svelte';
  import { MenuService } from '../services/MenuService.svelte';

  interface Props extends HTMLAttributes<HTMLElement> {
    variant?: NavigationVariant;
  }

  const { variant, ...toNext }: Props = $props();
  const MenuPoints: NavPoints = $derived(MenuService.menuNavigation);
</script>

<nav {...toNext} class="LayoutNavigation" aria-label={CommonTexts.MainNavigation}>
  <Navigation {variant} points={MenuPoints} />
</nav>

<style lang="scss">
  @use '../../styles/display';
  @use '../../styles/mixins';

  .LayoutNavigation {
    --nav-inset-y: 0.7rem;
    --nav-inset-x: 0.75rem;

    @include mixins.greaterNav() {
      --nav-inset-y: 0.25rem;
      --nav-inset-x: 0.5rem;
    }

    :global(.layer1) {
      --nav-border-radius: calc(var(--border-radius) / 2);
      --nav-margin-top: calc(var(--outset-abs) / 2);
      --nav-box-shadow-hover: var(--box-shadow-basic);
      --nav-border-color-hover: var(--border-basic-color);
    }

    :global(.layer2) {
      --nav-font-size: calc(var(--font-size) * 0.75);
      --nav-margin-left: 1rem;
      --nav-border-radius: calc(var(--border-radius) / 4);
      --nav-margin-top: calc(var(--outset-abs) / 4);
      --nav-margin-top-first: calc(var(--outset-abs) / 2);
    }
  }
</style>
